import styled from "styled-components";
import CustomIcon from "../image/CustomIcon";
import { useRef, useState } from "react";
import { useClickOutside } from "../../hooks/useClickOutside";
import { Theme } from "../../Theme";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

const TooltipWrapper = styled.div`
    position: absolute;
    //top: -600%;
    top: ${({ top }) => top || "-600%"};
    left: -100%;
    z-index: 1000;
    margin-top: 8px;
    background-color: ${Theme.color.white};
    border-radius: 10px;
    border: 1px solid ${Theme.color.gray200};
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(30px);
    box-shadow: 0 4px 16px ${Theme.color.black_01};
    padding: 10px 14px;
    box-sizing: border-box;
    width: ${({ width }) => width || "362px"};
`;

function TooltipContent({ children, width = "352px", top }) {
    return (
        <TooltipWrapper width={width} top={top}>
            {children}
        </TooltipWrapper>
    );
}

function CustomTooltip({ children, width, top }) {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    const toggleTooltip = () => {
        setIsTooltipOpen((prev) => !prev);
    };

    const menuRef = useRef(null);
    useClickOutside(menuRef, () => {
        if (isTooltipOpen) {
            setIsTooltipOpen(false);
        }
    });

    return (
        <MenuContainer
            ref={menuRef}
            onClick={toggleTooltip}
            onMouseEnter={() => setIsTooltipOpen(true)}
            onMouseLeave={() => setIsTooltipOpen(false)}
        >
            <CustomIcon iconName={"information_circle_contained_grey"} size={"15.75px"} cursor={"pointer"} />
            {isTooltipOpen && <TooltipContent children={children} width={width} top={top} />}
        </MenuContainer>
    );
}

export default CustomTooltip;
